"use strict";

import $ from "jquery";
import map from "lodash/map";
import Sortable from "sortablejs";

const updateOrder = function (postUrl, data) {
  $.ajax(postUrl, {
    method: "POST",
    data: data,
    complete: function () {}
  });
};

const attachSortable = function () {
  const postUrl = $(this).data("sortable-post-url");
  if (!postUrl) {
    // eslint-disable-next-line no-console
    console.warn("Sortable list missing POST URL");
    return;
  }

  Sortable.create(this, {
    onUpdate: function (/**Event*/evt) {
      const data = map($(evt.item).closest("[data-sortable-water-data]").find("li"), function (e, i) {
        return {
          gid: $(e).data("gid"),
          order: i
        };
      });

      updateOrder(postUrl, {
        data: data
      });
    }
  });
};

$(document).on("turbolinks:load", function () {
  $("[data-sortable-water-data]").each(attachSortable);
});
